/**
 * Standard business categories for merchant General Settings.
 * Stored as plain text on the merchant record.
 */
export const MERCHANT_BUSINESS_CATEGORIES = [
    'Restaurant',
    'Café & coffee shop',
    'Bar & brewery',
    'Bakery & desserts',
    'Grocery & specialty food',
    'Retail & boutique',
    'Fashion & apparel',
    'Salon & barbershop',
    'Spa & wellness',
    'Fitness & gym',
    'Health & medical',
    'Professional services',
    'Automotive',
    'Home improvement & trades',
    'Cleaning & maintenance',
    'Pet care',
    'Childcare & education',
    'Arts & entertainment',
    'Hotel & lodging',
    'Travel & tourism',
    'Electronics & repair',
    'Event venue',
    'Nonprofit',
    'Other',
];

/**
 * Options for a category select, including the saved value when it is not in the standard list.
 */
export function getMerchantCategorySelectOptions(savedCategory) {
    const trimmed = (savedCategory || '').trim();
    const list = [...MERCHANT_BUSINESS_CATEGORIES];
    if (trimmed && !list.includes(trimmed)) {
        return [trimmed, ...list];
    }
    return list;
}